import styled, { css } from 'styled-components';
import { spacing } from '_utils/props';
import { mq, svg, color, heading_m, text_m, text_xscap, link, text_s } from '_utils/styles';

import { Grid } from '_utils/components/Corporate';
import ContentRichText from '../ContentRichText';

const statusThemes = {
  planned: css`
    path {
      fill: ${({ theme }) => theme.colors.all.deepBlueTint45};
    }
  `,
  completed: css`
    path {
      fill: ${({ theme }) => theme.colors.all.green};
    }
  `,
  closed: css`
    path {
      fill: ${({ theme }) => theme.colors.all.newtownFuchsia};
    }
  `,
  'under-review': css`
    path {
      fill: ${({ theme }) => theme.colors.all.annandaleOrange};
    }
  `,
  open: css`
    path {
      fill: ${({ theme }) => theme.colors.all.pyrmontBlueTint75};
    }
  `,
  'in-progress': css`
    path {
      fill: ${({ theme }) => theme.colors.all.centennialParkYellow};
    }
  `,
  book: css`
    path {
      fill: ${({ theme }) => theme.colors.all.white};
    }
  `
};

const handleStatusTheme = ({ statusStyle}) => statusThemes[statusStyle];

export const Container = styled(Grid.Container)`
  position: relative;
`;

export const InnerContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background.octonary};
  border-radius: 8px;
  ${({ theme }) => spacing({ theme, $p: 3 })};

  color: ${({ theme }) => theme.colors.element.white};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${mq('sm')} {
    flex-direction: row;
  }
`;

export const IconContainer = styled.div`
  flex: none;

  ${mq('md')} {
    margin-top: 2px;
  }
`;

export const DescriptionContainer = styled.div`
  flex: 1 1 auto;
  a {
    ${link}
    color: ${({ theme }) => theme.colors.element.white};
    &:visited {
      color: ${({ theme }) => theme.colors.link.secondary.colorVisited};
    }
  }
`;
export const IconWrapper = styled.div<{ $statusStyle?: keyof typeof statusThemes }>`
  ${svg(24, 24)}
  flex-shrink: 0;
  width: 24px;
  ${({ theme }) => spacing({ theme, $mb: 1 })};

  ${mq('sm')} {
    ${({ theme }) => spacing({ theme, $mb: 0, $mr: 2 })};
  }

  ${mq('lg')} {
    margin-top: -4px;
    width: 32px;
  }

  ${({ $statusStyle }) => $statusStyle && handleStatusTheme({ statusStyle: $statusStyle })}
`;

export const Title = styled.h2`
  ${heading_m}
  margin: 0;
`;

export const DateWrapper = styled.div``;

export const RichText = styled(ContentRichText)`
  > :last-child {
    margin-bottom: 0;
  }
`;

export const Description = styled.div`
  ${text_m}
`;
export const Date = styled.span`
  ${text_s}
`;
export const DateText = styled.span`
  ${text_xscap}
  opacity: 0.75;
  display: flex;
  margin: 0px;
`;

export const EditorDiv = styled.div``;
